module.exports = __webpack_public_path__ + "invalid_uturn.svg?f8e15e21b0434271879cfb6d9a07d324";


//////////////////
// WEBPACK FOOTER
// ./src/assets/diving_icons/invalid_uturn.svg
// module id = 176
// module chunks = 0